import { Alert, Button, Card, CardContent, CardHeader, Dialog } from '@mui/material';
import { snack } from 'components/Snack/Snack';
import { toDate, toFullDateName } from 'helpers/dateHelper';
import { withRemoteDataAndSpinner } from 'hoc/withRemoteDataAndSpinner';
import withRouter from 'hoc/withRouter';
import { useLoadAll } from 'hooks/useLoadAll';
import { useState } from 'react'
import { Link } from 'react-router-dom';
import './sub-orders.scss'
import _ from 'lodash';
import { genderEnum } from 'enums/genders';
import subOrdersService from 'services/admin/sub-orders.service';
import { OrderStatus } from 'components/OrderStatus';
import { ORDER_STATUS } from 'data/i18n';
import { SubOrderPayments } from 'components/SubOrderPayments';
import { PaymentFormDialog } from 'components/PaymentFormDialog/PaymentFormDialog';
import paymentHistoriesService from 'services/admin/paymentHistoriesService';
import { TourPackageShortPreview } from 'components/TourPackageShortPreview/TourPackageShortPreview';
import { toCurrencyFormat } from 'helpers/utils';

const BookingDetailsV2 = ({
    router: {
        params: { id },
    },
    data: {
        subOrder,
    },
}) => {
    // Платеж который будет передаваться к dialog
    const [payment, setPayment] = useState(null)
    const [isPaymentDialogVisible, setIsPaymentDialogVisible] = useState(false)

    // Вызывается когда добавляем платеж или оформляем возврат
    const onSubmitPayment = async (formValues) => {
        try {
            console.log(`formValues:`, formValues);
            if (formValues.id) {
                await paymentHistoriesService.put(formValues.id, { subOrderID: id })
            } else {
                await paymentHistoriesService.post(formValues, { subOrderID: id })

                snack('Платеж успешно добавлен!')

                setTimeout(() => {
                    window.location.reload()
                }, 1000);
            }
        } catch (ex) {
            console.error(ex)
            snack(`При добавление платежа вышли ошибка: ${ex?.message}`)
        } finally {
            setIsPaymentDialogVisible(false)
        }
    }

    const completeOrder = async () => {
        try {
            if (subOrder) {
                const { data } = await subOrdersService.completeOrder(subOrder.id)
                snack(data.message)
                setTimeout(() => {
                    window.location.reload()
                }, 1000);
            }
        } catch (ex) {
            console.error('cancelOrder ex:', ex)
            snack(`Во время отмены заказа вышла ошибка: ${ex?.message}`)
        }
    }
    const cancelOrder = async () => {
        try {
            if (subOrder) {
                const { data } = await subOrdersService.cancelOrder(subOrder.id)
                snack(data.message)
                setTimeout(() => {
                    window.location.reload()
                }, 1000);
            }
        } catch (ex) {
            console.error('cancelOrder ex:', ex)
            snack(`Во время отмены заказа вышла ошибка: ${ex?.message}`)
        }
    }
    const refundOrder = async () => {
        try {
            if (subOrder) {
                const { data } = await subOrdersService.refundOrder(subOrder.id)
                snack(data.message)
                setTimeout(() => {
                    window.location.reload()
                }, 1000);
            }
        } catch (ex) {
            console.error('refundOrder ex:', ex)
            snack(`Во время оформления возврата вышла ошибка: ${ex?.message}`)
        }
    }
    function subOrderButtons() {
        /**
         * Завершить заказ - отображать когда заказ СОЗДАН или ОПЛАЧЕНО ЧАСТИЧНО
         * Оформить возврат - отображать когда денежные средства получены: то есть ОПЛАЧЕНО ЧАСТИЧНО и оплачено полностью
        */
        if ([ORDER_STATUS.NEW].includes(subOrder.status)) {
            return <>
                <div className='flex gap-16'>
                    <Button type="button" variant="outlined" onClick={cancelOrder} color='error'>Отменить заказ</Button>
                </div>

            </>
        }
        if ([ORDER_STATUS.PAID].includes(subOrder.status)) {
            // Если заказ оплачен частично то отображаем завершить заказ и оформить возврат.
            return <div className='flex gap-16'>                
                {/* <Button type="button" variant="outlined" onClick={refundOrder} color='error'>Оформить возврат</Button> */}
            </div>
        }
        if ([ORDER_STATUS.COMPLETED].includes(subOrder.status)) {
            //  Все равно разрешаем делать возврат после получения полной суммы 
            return <div className='flex gap-16'>
                <Button type="button" variant="outlined" onClick={refundOrder} color='error'>Оформить возврат</Button>
            </div>
        }

        if ([ORDER_STATUS.REFUNDED].includes(subOrder.status)) {
            // Если заказ статус возврат то ничего не отображаем
            return null
        }

        return null
    }

    const showPaymentDialog = (operationType) => {
        setPayment({
            operationType
        })
        setIsPaymentDialogVisible(true)
    }

    return (
        <div className='m-b-64'>
            <div>
                <Card className='p-16 m-b-32'>
                    <CardHeader title="Данные о заказе">
                        Данные о заказе
                    </CardHeader>
                    <CardContent>
                        <div className='profile'>
                            <div className="m-b-16">
                                <strong>Номер заказа:</strong> #{subOrder.id}
                            </div>
                            <div className="m-b-16">
                                <strong>Дата создания заказа: </strong>
                                <span>{subOrder.createdAt ? toDate(subOrder.createdAt) : 'Отсутсвует'}</span>
                            </div>
                            <div className="m-b-16">
                                <strong>Дата последнего изменения: </strong>
                                <span>{subOrder.updatedAt ? toDate(subOrder.updatedAt) : 'Отсутсвует'}</span>
                            </div>
                            <div className="m-b-16">
                                <strong>Прикрепленный менеджер: </strong>
                                <span>{subOrder.manager?.name ? <Link className="color-blue" target="_blank" to={`/admin/members/view/${subOrder.manager.id}`}>{subOrder.manager?.name}</Link> : 'Отсутсвует'}</span>
                            </div>
                            <div className="m-b-16">
                                <strong>Статус заказа: </strong>
                                <OrderStatus status={subOrder.status} subStatus={subOrder.subStatus}></OrderStatus>
                            </div>
                            <div className="m-b-16">
                                <strong>Общая сумма к оплате: </strong>
                                <span> {toCurrencyFormat(subOrder.totalAmount, subOrder.currency)}</span>
                            </div>
                            {/* <div className="m-t-16 gap-2 flex">
                                <strong>Оплатить до:</strong>
                                <span>{toFullDateName(subOrder.tourPackage.startDate)}</span>
                                <strong className='color-green'> {diffInDays(subOrder.tourPackage?.startDate, new Date()) > 0 ? `(осталось ${diffInDays(subOrder.tourPackage?.startDate, new Date())} дней)` : null}</strong>
                            </div> */}
                            <div>
                                <span>Заметка:</span>
                                <p>{subOrder.comment}</p>
                            </div>
                        </div>
                    </CardContent>
                </Card>
                <Card className='p-16 m-b-32'>
                    <CardHeader title="Данные о покупателе" subheader="Покупатель не обязательно сам турист"></CardHeader>
                    <CardContent>
                        {subOrder.customer ? <>
                            <p><Link className='color-blue' target='_blank' to={`/admin/customers/view/${subOrder.customer.id}`}>{subOrder.customer.lastName} {subOrder.customer.firstName}</Link></p>
                            <p>Номер телефона: <span>+{_.get(subOrder, 'customer.user.phone')}</span></p>
                            <p>ИИН: <span>{_.get(subOrder, 'customer.IDCard.iin')}</span></p>
                            <p>Является клиентом: {toFullDateName(subOrder.csutomer?.createdAt)}</p>
                        </> : null}
                    </CardContent>
                </Card>
                <h2 className='m-t-32 m-b-16'>Список туристов:</h2>
                {subOrder.orderItems.map((oi, inx) => {
                    return <Card className='p-16 m-b-32' key={inx}>
                        <CardHeader subheader={`${inx + 1}-турист`}></CardHeader>
                        <CardContent>
                            <div className='m-b-16 flex gap-16 flex-between'>
                                <section>
                                    <div key={oi.id} className='m-b-8'>
                                        <Link className='color-blue' to={`/admin/customers/view/${oi.customer.id}`}>
                                            <strong>{`${oi.customer.lastName} ${oi.customer.firstName}` || oi.customer.ID}</strong>
                                        </Link>
                                    </div>
                                    <div className='m-b-8'>
                                        <span>Дата рождения: </span><span>{_.get(oi, 'customer.birthdate')}</span>
                                    </div>
                                    <div className='m-b-8'>
                                        <span>Телефон: </span><span>{_.get(oi, 'customer.user.phone')}</span>
                                    </div>
                                    <div className='m-b-8'>
                                        <span>Пол: </span><span>{_.has(oi, 'customer.gender') ? genderEnum[_.get(oi, 'customer.gender')] : null}</span>
                                    </div>
                                    <div className='m-b-8'>
                                        <span>Гражданство: </span><span>{_.get(oi, 'customer.citizenship')}</span>
                                    </div>
                                    <div className='m-t-8'>Является клиентом с {toFullDateName(_.get(oi, 'customer.createdAt'))}</div>
                                </section>
                                <section>
                                    <h4 className='m-b-16'>Удостоверение личности</h4>
                                    <div className='m-b-8 flex gap-8'>
                                        <div>
                                            <span>ИИН: </span><span>{_.get(oi, 'customer.IDCard.iin')}</span>
                                        </div>
                                    </div>
                                </section>
                                <section>
                                    <h4 className='m-b-16'>Паспорт</h4>
                                    <div className='m-b-8'>
                                        {_.has(oi, 'passport.dateOfIssue') ?
                                            <div>
                                                <span>Дата выдачи: </span><span>{_.get(oi, 'customer.passport.dateOfIssue')}</span>
                                            </div> : null
                                        }
                                        <div>
                                            <span>Годен до: </span><span>{_.get(oi, 'customer.passport.dateOfExpire')}</span>
                                        </div>
                                        <div>
                                            <span>Номер: </span><span>{_.get(oi, 'customer.passport.number')}</span>
                                        </div>
                                    </div>
                                </section>
                            </div>
                            <hr/>
                            <section>
                                <div className='m-b-16 m-t-16'>Выбранный турпакет</div>
                                <TourPackageShortPreview id={_.get(oi, 'itemID')}></TourPackageShortPreview>
                            </section>
                            <hr className='m-t-16 m-b-16' />
                            <div className='fw-500'>
                                Сумма к оплате: {toCurrencyFormat(_.get(oi, 'subtotal'), _.get(oi, 'currency'))}
                            </div>
                        </CardContent>
                    </Card>
                })}
                <SubOrderPayments subOrder={subOrder} onClose={showPaymentDialog}></SubOrderPayments>

                <Alert className='m-t-32 m-b-32' color='info'>
                    <div className='m-b-16'><strong>Обратите внимание: </strong>Заказы могут быть находиться в следующих статусах:</div>
                    <ul className=''>
                        <li>
                            <strong>Новый</strong>. Заказ только что создан, ожидает обработки менеджером.
                        </li>
                        <li>
                            <strong>Ожидание оплаты</strong>: Система ожидает, когда клиент произведет оплату. Это может происходить через различные методы оплаты, такие как кредитные карты, электронные кошельки, банковские переводы и т.д.
                        </li>
                        <li>
                            <strong>"Завершен"</strong>. Заказ считается завершенным только после того, как вся сумма была оплачена (либо полная оплата, либо все предоплаты были получены и покрывают общую сумму). Заказ больше не требует дальнейших действий со стороны бизнеса или клиента, и все обязательства выполнены.</li>
                        <li>
                            <strong>Отменен.</strong> Заказ отменен по какой-либо причине. Например: клиент отказался от поездки или менеджер создал неправильный заказ                     </li>
                        <li>
                            <strong>Возврат</strong>. Оформляется возврат по заказу (полностью или частично).
                        </li>
                        <li>Примечание: После завершения, оформление возврата или отмены заказа вы больше не можете редактировать заказ!</li>
                    </ul>
                </Alert>
                {subOrderButtons()}
            </div>
            <Dialog open={isPaymentDialogVisible}
                onClose={() => { setIsPaymentDialogVisible(false) }}
                className='p-16 w-100'
                fullWidth
                maxWidth="sm">
                <PaymentFormDialog
                    onSubmit={onSubmitPayment}
                    payment={payment}></PaymentFormDialog>
            </Dialog>
        </div>
    )
}

export default withRouter(
    withRemoteDataAndSpinner(BookingDetailsV2, (router) => {
        let requests = {}
        if (router.params.id) {
            requests['subOrder'] = () => subOrdersService.get(router.params.id)
        }
        return useLoadAll(requests);
    })
);